module.exports = __webpack_public_path__ + "img/mytarget.b9ba675a.svg";